import React from "react";
import DrawerItem from "./DrawerItem";
import { List, ListItem } from "@mui/material";

const styles = {
  width: "13%",
  bgcolor: "rgb(77, 81, 82)",
  color: "white",
  height: "100%",
  overflow: "auto",
};
export default function Drawer({ items }) {
  return (
    <List sx={styles} component="nav" aria-labelledby="nested-list-subheader">
      {items &&
        items.map((item, index) => <DrawerItem key={item.title} item={item} />)}
    </List>
  );
}
